
/**
 * Utility css-selector-parser-utility
 * @description Parse a CSS selector into an object.
 * @copyright 2018-4-12
 * @file
 */

/* eslint-disable import/prefer-default-export */

/**
 * @param {String} selector CSS selector.
 * @returns {Object} Parsed selector.
 */
export function parseSelector(selector) {
  const types = {
    '#': 'id',
    '.': 'class',
    '[': 'attributeStart',
    ']': 'attributeEnd',
    '=': 'attributeSet',
    '"': 'quote',
    "'": 'quote',
  };

  const parsed = {
    tag: '',
    id: '',
    class: '',
    attrs: {},
    currentAttributeName: '',
    currentAttributeValue: '',
  };

  [...selector].forEach((char) => {
    const notOtherTypes = !types[char];
    const isId = char === '#' || (parsed.currentType === 'id' && notOtherTypes);
    const isClass = char === '.' || (parsed.currentType === 'class' && notOtherTypes);
    const isAttributeStart = char === '[' || (parsed.currentType === 'attributeStart' && notOtherTypes);
    const isAttributeEnd = char === ']' || (parsed.currentType === 'attributeEnd' && notOtherTypes);
    const isAttributeSet = (
      char === '=' ||
      char === '"' ||
      char === "'" ||
      (parsed.currentType === 'attributeSet' && notOtherTypes)
    );

    if (isId) {
      parsed.currentType = 'id';
      if (char !== '#') parsed.id += char;
      return;
    }

    if (isClass) {
      parsed.currentType = 'class';
      if (char === '.') parsed.class += ' '; // starting new class name
      if (char !== '.') parsed.class += char;
      return;
    }

    if (isAttributeStart) {
      parsed.currentType = 'attributeStart';
      if (char !== '[') parsed.currentAttributeName += char;
      return;
    }

    if (isAttributeSet) {
      parsed.currentType = 'attributeSet';

      if (char !== '=' && char !== '"' && char !== "'") parsed.currentAttributeValue += char;

      return;
    }

    if (isAttributeEnd) {
      parsed.currentType = 'attributeEnd';

      parsed.attrs[parsed.currentAttributeName] = parsed.currentAttributeValue;

      parsed.currentAttributeName = '';
      parsed.currentAttributeValue = '';

      return;
    }

    parsed.currentType = 'tag';
    parsed.tag += char;
  });

  return {
    tag: parsed.tag || undefined,
    id: parsed.id || undefined,
    class: parsed.class.slice(1) || undefined,
    attrs: parsed.attrs,
  };
}
